export default "__VITE_ASSET__c200f112__"